/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ApiConfig from './apiConfig';

export class BaseClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/Base?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class InvoicesClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    getAll(): Promise<InvoiceHead[]> {
        let url_ = this.baseUrl + '/api/invoices';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetAll(_response);
            });
    }

    protected processGetAll(response: Response): Promise<InvoiceHead[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(InvoiceHead.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceHead[]>(null as any);
    }

    /**
     * @return OK
     */
    get(id: string): Promise<InvoiceHead> {
        let url_ = this.baseUrl + '/api/invoices/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<InvoiceHead> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InvoiceHead.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceHead>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/Invoices?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class NewsClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    get(): Promise<News[]> {
        let url_ = this.baseUrl + '/api/news';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<News[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(News.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<News[]>(null as any);
    }

    /**
     * @return OK
     */
    getInternal(): Promise<News[]> {
        let url_ = this.baseUrl + '/api/news/internal';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetInternal(_response);
            });
    }

    protected processGetInternal(response: Response): Promise<News[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(News.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<News[]>(null as any);
    }

    /**
     * @return OK
     */
    getDocument(id: string, token: string): Promise<any> {
        let url_ = this.baseUrl + '/api/news/document/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else url_ += 'token=' + encodeURIComponent('' + token) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetDocument(_response);
            });
    }

    protected processGetDocument(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/News?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class OpportunitiesClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    get(): Promise<OpportunityHead[]> {
        let url_ = this.baseUrl + '/api/opportunities';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<OpportunityHead[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OpportunityHead.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpportunityHead[]>(null as any);
    }

    /**
     * @return OK
     */
    setRating(opportunityId: string, rate: Rate): Promise<boolean> {
        let url_ = this.baseUrl + '/api/opportunities/setrating?';
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined and cannot be null.");
        else url_ += 'opportunityId=' + encodeURIComponent('' + opportunityId) + '&';
        if (rate === undefined || rate === null)
            throw new Error("The parameter 'rate' must be defined and cannot be null.");
        else url_ += 'rate=' + encodeURIComponent('' + rate) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processSetRating(_response);
            });
    }

    protected processSetRating(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addComment(comment: Comment): Promise<boolean> {
        let url_ = this.baseUrl + '/api/opportunities/addcomment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddComment(_response);
            });
    }

    protected processAddComment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getcomments(opportunityId: string): Promise<Comment[]> {
        let url_ = this.baseUrl + '/api/opportunities/comments?';
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined and cannot be null.");
        else url_ += 'opportunityId=' + encodeURIComponent('' + opportunityId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetcomments(_response);
            });
    }

    protected processGetcomments(response: Response): Promise<Comment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(Comment.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Comment[]>(null as any);
    }

    /**
     * @return OK
     */
    setStatus(opportunityId: string, statusCode: StatusCode): Promise<boolean> {
        let url_ = this.baseUrl + '/api/opportunities/setstatus?';
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined and cannot be null.");
        else url_ += 'opportunityId=' + encodeURIComponent('' + opportunityId) + '&';
        if (statusCode === undefined || statusCode === null)
            throw new Error("The parameter 'statusCode' must be defined and cannot be null.");
        else url_ += 'statusCode=' + encodeURIComponent('' + statusCode) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processSetStatus(_response);
            });
    }

    protected processSetStatus(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/Opportunities?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class OrdersClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    getAll(): Promise<OrderHead[]> {
        let url_ = this.baseUrl + '/api/orders';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetAll(_response);
            });
    }

    protected processGetAll(response: Response): Promise<OrderHead[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(OrderHead.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderHead[]>(null as any);
    }

    /**
     * @return OK
     */
    get(id: string): Promise<OrderHead> {
        let url_ = this.baseUrl + '/api/orders/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<OrderHead> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderHead.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderHead>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/Orders?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class ProjectsClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    get(): Promise<ProjectHead[]> {
        let url_ = this.baseUrl + '/api/projects';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<ProjectHead[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ProjectHead.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectHead[]>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/Projects?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class ShipmentsClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    getAll(): Promise<ShipmentHead[]> {
        let url_ = this.baseUrl + '/api/shipments';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetAll(_response);
            });
    }

    protected processGetAll(response: Response): Promise<ShipmentHead[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200!.push(ShipmentHead.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipmentHead[]>(null as any);
    }

    /**
     * @return OK
     */
    get(id: string): Promise<ShipmentHead> {
        let url_ = this.baseUrl + '/api/shipments/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<ShipmentHead> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ShipmentHead.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipmentHead>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/Shipments?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class UserClient extends ApiConfig {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = this.getBaseUrl('http://localhost:59034', baseUrl);
    }

    /**
     * @return OK
     */
    get(): Promise<UserInfo> {
        let url_ = this.baseUrl + '/api/users';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGet(_response);
            });
    }

    protected processGet(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserInfo.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    /**
     * @return OK
     */
    getUser(authenticationString: string): Promise<UserBridge> {
        let url_ = this.baseUrl + '/api/User?';
        if (authenticationString === undefined || authenticationString === null)
            throw new Error("The parameter 'authenticationString' must be defined and cannot be null.");
        else url_ += 'authenticationString=' + encodeURIComponent('' + authenticationString) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetUser(_response);
            });
    }

    protected processGetUser(response: Response): Promise<UserBridge> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserBridge.fromJS(resultData200);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBridge>(null as any);
    }
}

export class UserBridge implements IUserBridge {
    adUserId?: string | undefined;
    crmContactId?: string | undefined;
    crmAccountId?: string | undefined;
    emailAddress?: string | undefined;
    firstname?: string | undefined;
    lastName?: string | undefined;
    readonly fullName?: string | undefined;
    territoryId1?: string | undefined;
    numUser?: User | undefined;

    constructor(data?: IUserBridge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adUserId = _data['AdUserId'];
            this.crmContactId = _data['CrmContactId'];
            this.crmAccountId = _data['CrmAccountId'];
            this.emailAddress = _data['EmailAddress'];
            this.firstname = _data['Firstname'];
            this.lastName = _data['LastName'];
            (<any>this).fullName = _data['FullName'];
            this.territoryId1 = _data['TerritoryId1'];
            this.numUser = _data['NumUser'] ? User.fromJS(_data['NumUser']) : <any>undefined;
        }
    }

    static fromJS(data: any): UserBridge {
        data = typeof data === 'object' ? data : {};
        let result = new UserBridge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['AdUserId'] = this.adUserId;
        data['CrmContactId'] = this.crmContactId;
        data['CrmAccountId'] = this.crmAccountId;
        data['EmailAddress'] = this.emailAddress;
        data['Firstname'] = this.firstname;
        data['LastName'] = this.lastName;
        data['FullName'] = this.fullName;
        data['TerritoryId1'] = this.territoryId1;
        data['NumUser'] = this.numUser ? this.numUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserBridge {
    adUserId?: string | undefined;
    crmContactId?: string | undefined;
    crmAccountId?: string | undefined;
    emailAddress?: string | undefined;
    firstname?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    territoryId1?: string | undefined;
    numUser?: User | undefined;
}

export class User implements IUser {
    type?: string | undefined;
    userObjectId?: string | undefined;
    grantId?: string | undefined;
    roleId?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    instanceId?: string | undefined;
    instanceUrl?: string | undefined;
    tenantId?: string | undefined;
    displayName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    roleName?: string | undefined;
    status?: string | undefined;
    updated?: Date | undefined;
    all?: boolean | undefined;
    leads?: boolean | undefined;
    orders?: boolean | undefined;
    invoices?: boolean | undefined;
    ductDesign?: boolean | undefined;
    qFV?: boolean | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data['type'];
            this.userObjectId = _data['userObjectId'];
            this.grantId = _data['grantId'];
            this.roleId = _data['roleId'];
            this.companyId = _data['companyId'];
            this.companyName = _data['companyName'];
            this.instanceId = _data['instanceId'];
            this.instanceUrl = _data['instanceUrl'];
            this.tenantId = _data['tenantId'];
            this.displayName = _data['displayName'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.email = _data['email'];
            this.roleName = _data['roleName'];
            this.status = _data['status'];
            this.updated = _data['updated'] ? new Date(_data['updated'].toString()) : <any>undefined;
            this.all = _data['all'];
            this.leads = _data['leads'];
            this.orders = _data['orders'];
            this.invoices = _data['invoices'];
            this.ductDesign = _data['ductDesign'];
            this.qFV = _data['QFV'];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['type'] = this.type;
        data['userObjectId'] = this.userObjectId;
        data['grantId'] = this.grantId;
        data['roleId'] = this.roleId;
        data['companyId'] = this.companyId;
        data['companyName'] = this.companyName;
        data['instanceId'] = this.instanceId;
        data['instanceUrl'] = this.instanceUrl;
        data['tenantId'] = this.tenantId;
        data['displayName'] = this.displayName;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['email'] = this.email;
        data['roleName'] = this.roleName;
        data['status'] = this.status;
        data['updated'] = this.updated ? this.updated.toISOString() : <any>undefined;
        data['all'] = this.all;
        data['leads'] = this.leads;
        data['orders'] = this.orders;
        data['invoices'] = this.invoices;
        data['ductDesign'] = this.ductDesign;
        data['QFV'] = this.qFV;
        return data;
    }
}

export interface IUser {
    type?: string | undefined;
    userObjectId?: string | undefined;
    grantId?: string | undefined;
    roleId?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    instanceId?: string | undefined;
    instanceUrl?: string | undefined;
    tenantId?: string | undefined;
    displayName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    roleName?: string | undefined;
    status?: string | undefined;
    updated?: Date | undefined;
    all?: boolean | undefined;
    leads?: boolean | undefined;
    orders?: boolean | undefined;
    invoices?: boolean | undefined;
    ductDesign?: boolean | undefined;
    qFV?: boolean | undefined;
}

export class InvoiceHead implements IInvoiceHead {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    dueDate?: Date | undefined;
    orderNumber?: string | undefined;
    balance?: number | undefined;
    orderId?: string | undefined;
    pONumber?: string | undefined;
    invoiceDate?: Date | undefined;
    totalAmount?: number | undefined;
    freightAmount?: number | undefined;
    productAmount?: number | undefined;
    taxAmount?: number | undefined;
    materialSurchange?: number | undefined;
    miscChanges?: number | undefined;
    invoiceRows?: InvoiceRow[] | undefined;
    shipToName?: string | undefined;
    shipToAddress?: string | undefined;
    shipToState?: string | undefined;
    shipToCity?: string | undefined;
    customerName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;

    constructor(data?: IInvoiceHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data['InvoiceId'];
            this.invoiceNumber = _data['InvoiceNumber'];
            this.dueDate = _data['DueDate'] ? new Date(_data['DueDate'].toString()) : <any>undefined;
            this.orderNumber = _data['OrderNumber'];
            this.balance = _data['Balance'];
            this.orderId = _data['OrderId'];
            this.pONumber = _data['PONumber'];
            this.invoiceDate = _data['InvoiceDate'] ? new Date(_data['InvoiceDate'].toString()) : <any>undefined;
            this.totalAmount = _data['TotalAmount'];
            this.freightAmount = _data['FreightAmount'];
            this.productAmount = _data['ProductAmount'];
            this.taxAmount = _data['TaxAmount'];
            this.materialSurchange = _data['MaterialSurchange'];
            this.miscChanges = _data['MiscChanges'];
            if (Array.isArray(_data['InvoiceRows'])) {
                this.invoiceRows = [] as any;
                for (let item of _data['InvoiceRows']) this.invoiceRows!.push(InvoiceRow.fromJS(item));
            }
            this.shipToName = _data['ShipToName'];
            this.shipToAddress = _data['ShipToAddress'];
            this.shipToState = _data['ShipToState'];
            this.shipToCity = _data['ShipToCity'];
            this.customerName = _data['CustomerName'];
            this.address = _data['Address'];
            this.city = _data['City'];
            this.state = _data['State'];
            this.country = _data['Country'];
        }
    }

    static fromJS(data: any): InvoiceHead {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['InvoiceId'] = this.invoiceId;
        data['InvoiceNumber'] = this.invoiceNumber;
        data['DueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data['OrderNumber'] = this.orderNumber;
        data['Balance'] = this.balance;
        data['OrderId'] = this.orderId;
        data['PONumber'] = this.pONumber;
        data['InvoiceDate'] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data['TotalAmount'] = this.totalAmount;
        data['FreightAmount'] = this.freightAmount;
        data['ProductAmount'] = this.productAmount;
        data['TaxAmount'] = this.taxAmount;
        data['MaterialSurchange'] = this.materialSurchange;
        data['MiscChanges'] = this.miscChanges;
        if (Array.isArray(this.invoiceRows)) {
            data['InvoiceRows'] = [];
            for (let item of this.invoiceRows) data['InvoiceRows'].push(item ? item.toJSON() : <any>undefined);
        }
        data['ShipToName'] = this.shipToName;
        data['ShipToAddress'] = this.shipToAddress;
        data['ShipToState'] = this.shipToState;
        data['ShipToCity'] = this.shipToCity;
        data['CustomerName'] = this.customerName;
        data['Address'] = this.address;
        data['City'] = this.city;
        data['State'] = this.state;
        data['Country'] = this.country;
        return data;
    }
}

export interface IInvoiceHead {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    dueDate?: Date | undefined;
    orderNumber?: string | undefined;
    balance?: number | undefined;
    orderId?: string | undefined;
    pONumber?: string | undefined;
    invoiceDate?: Date | undefined;
    totalAmount?: number | undefined;
    freightAmount?: number | undefined;
    productAmount?: number | undefined;
    taxAmount?: number | undefined;
    materialSurchange?: number | undefined;
    miscChanges?: number | undefined;
    invoiceRows?: InvoiceRow[] | undefined;
    shipToName?: string | undefined;
    shipToAddress?: string | undefined;
    shipToState?: string | undefined;
    shipToCity?: string | undefined;
    customerName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
}

export class InvoiceRow implements IInvoiceRow {
    lineNumber?: number | undefined;
    itemNumber?: string | undefined;
    orderedQty?: number | undefined;
    deliveredQty?: number | undefined;
    backorderQty?: number | undefined;
    unitPrice?: number | undefined;
    discount?: number | undefined;
    amount?: number | undefined;
    description?: string | undefined;

    constructor(data?: IInvoiceRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data['LineNumber'];
            this.itemNumber = _data['ItemNumber'];
            this.orderedQty = _data['OrderedQty'];
            this.deliveredQty = _data['DeliveredQty'];
            this.backorderQty = _data['BackorderQty'];
            this.unitPrice = _data['UnitPrice'];
            this.discount = _data['Discount'];
            this.amount = _data['Amount'];
            this.description = _data['Description'];
        }
    }

    static fromJS(data: any): InvoiceRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['LineNumber'] = this.lineNumber;
        data['ItemNumber'] = this.itemNumber;
        data['OrderedQty'] = this.orderedQty;
        data['DeliveredQty'] = this.deliveredQty;
        data['BackorderQty'] = this.backorderQty;
        data['UnitPrice'] = this.unitPrice;
        data['Discount'] = this.discount;
        data['Amount'] = this.amount;
        data['Description'] = this.description;
        return data;
    }
}

export interface IInvoiceRow {
    lineNumber?: number | undefined;
    itemNumber?: string | undefined;
    orderedQty?: number | undefined;
    deliveredQty?: number | undefined;
    backorderQty?: number | undefined;
    unitPrice?: number | undefined;
    discount?: number | undefined;
    amount?: number | undefined;
    description?: string | undefined;
}

export class News implements INews {
    topic?: string | undefined;
    url?: string | undefined;
    publishDate?: Date | undefined;
    description?: string | undefined;
    attachmentExists?: boolean | undefined;
    attachmentId?: string | undefined;
    newsId?: string | undefined;
    expiryDate?: Date | undefined;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data['Topic'];
            this.url = _data['Url'];
            this.publishDate = _data['PublishDate'] ? new Date(_data['PublishDate'].toString()) : <any>undefined;
            this.description = _data['Description'];
            this.attachmentExists = _data['AttachmentExists'];
            this.attachmentId = _data['AttachmentId'];
            this.newsId = _data['NewsId'];
            this.expiryDate = _data['ExpiryDate'] ? new Date(_data['ExpiryDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['Topic'] = this.topic;
        data['Url'] = this.url;
        data['PublishDate'] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data['Description'] = this.description;
        data['AttachmentExists'] = this.attachmentExists;
        data['AttachmentId'] = this.attachmentId;
        data['NewsId'] = this.newsId;
        data['ExpiryDate'] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INews {
    topic?: string | undefined;
    url?: string | undefined;
    publishDate?: Date | undefined;
    description?: string | undefined;
    attachmentExists?: boolean | undefined;
    attachmentId?: string | undefined;
    newsId?: string | undefined;
    expiryDate?: Date | undefined;
}

export class OpportunityHead implements IOpportunityHead {
    name?: string | undefined;
    company?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    topic?: string | undefined;
    opportunityId?: string | undefined;
    rate?: OpportunityHeadRate | undefined;
    statusCode?: OpportunityHeadStatusCode | undefined;
    industry?: string | undefined;

    constructor(data?: IOpportunityHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['Name'];
            this.company = _data['Company'];
            this.city = _data['City'];
            this.state = _data['State'];
            this.email = _data['Email'];
            this.phoneNumber = _data['PhoneNumber'];
            this.description = _data['Description'];
            this.createdDate = _data['CreatedDate'] ? new Date(_data['CreatedDate'].toString()) : <any>undefined;
            this.topic = _data['Topic'];
            this.opportunityId = _data['OpportunityId'];
            this.rate = _data['Rate'];
            this.statusCode = _data['StatusCode'];
            this.industry = _data['Industry'];
        }
    }

    static fromJS(data: any): OpportunityHead {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['Name'] = this.name;
        data['Company'] = this.company;
        data['City'] = this.city;
        data['State'] = this.state;
        data['Email'] = this.email;
        data['PhoneNumber'] = this.phoneNumber;
        data['Description'] = this.description;
        data['CreatedDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data['Topic'] = this.topic;
        data['OpportunityId'] = this.opportunityId;
        data['Rate'] = this.rate;
        data['StatusCode'] = this.statusCode;
        data['Industry'] = this.industry;
        return data;
    }
}

export interface IOpportunityHead {
    name?: string | undefined;
    company?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    topic?: string | undefined;
    opportunityId?: string | undefined;
    rate?: OpportunityHeadRate | undefined;
    statusCode?: OpportunityHeadStatusCode | undefined;
    industry?: string | undefined;
}

export class Comment implements IComment {
    opportunityId?: string | undefined;
    commentDate?: Date | undefined;
    information?: string | undefined;

    constructor(data?: IComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data['OpportunityId'];
            this.commentDate = _data['CommentDate'] ? new Date(_data['CommentDate'].toString()) : <any>undefined;
            this.information = _data['Information'];
        }
    }

    static fromJS(data: any): Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['OpportunityId'] = this.opportunityId;
        data['CommentDate'] = this.commentDate ? this.commentDate.toISOString() : <any>undefined;
        data['Information'] = this.information;
        return data;
    }
}

export interface IComment {
    opportunityId?: string | undefined;
    commentDate?: Date | undefined;
    information?: string | undefined;
}

export class OrderHead implements IOrderHead {
    orderNumber?: string | undefined;
    customer?: string | undefined;
    territory?: string | undefined;
    orderReference?: string | undefined;
    orderDate?: Date | undefined;
    purchaseOrder?: string | undefined;
    shippingName?: string | undefined;
    shippingAddress?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingPostalCode?: string | undefined;
    shippingPhone?: string | undefined;
    shippingFax?: string | undefined;
    estimatedShipDate?: Date | undefined;
    orderId?: string | undefined;
    orderRows?: OrderRows[] | undefined;

    constructor(data?: IOrderHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data['OrderNumber'];
            this.customer = _data['Customer'];
            this.territory = _data['Territory'];
            this.orderReference = _data['OrderReference'];
            this.orderDate = _data['OrderDate'] ? new Date(_data['OrderDate'].toString()) : <any>undefined;
            this.purchaseOrder = _data['PurchaseOrder'];
            this.shippingName = _data['ShippingName'];
            this.shippingAddress = _data['ShippingAddress'];
            this.shippingCity = _data['ShippingCity'];
            this.shippingState = _data['ShippingState'];
            this.shippingPostalCode = _data['ShippingPostalCode'];
            this.shippingPhone = _data['ShippingPhone'];
            this.shippingFax = _data['ShippingFax'];
            this.estimatedShipDate = _data['EstimatedShipDate']
                ? new Date(_data['EstimatedShipDate'].toString())
                : <any>undefined;
            this.orderId = _data['OrderId'];
            if (Array.isArray(_data['OrderRows'])) {
                this.orderRows = [] as any;
                for (let item of _data['OrderRows']) this.orderRows!.push(OrderRows.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderHead {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['OrderNumber'] = this.orderNumber;
        data['Customer'] = this.customer;
        data['Territory'] = this.territory;
        data['OrderReference'] = this.orderReference;
        data['OrderDate'] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data['PurchaseOrder'] = this.purchaseOrder;
        data['ShippingName'] = this.shippingName;
        data['ShippingAddress'] = this.shippingAddress;
        data['ShippingCity'] = this.shippingCity;
        data['ShippingState'] = this.shippingState;
        data['ShippingPostalCode'] = this.shippingPostalCode;
        data['ShippingPhone'] = this.shippingPhone;
        data['ShippingFax'] = this.shippingFax;
        data['EstimatedShipDate'] = this.estimatedShipDate ? this.estimatedShipDate.toISOString() : <any>undefined;
        data['OrderId'] = this.orderId;
        if (Array.isArray(this.orderRows)) {
            data['OrderRows'] = [];
            for (let item of this.orderRows) data['OrderRows'].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IOrderHead {
    orderNumber?: string | undefined;
    customer?: string | undefined;
    territory?: string | undefined;
    orderReference?: string | undefined;
    orderDate?: Date | undefined;
    purchaseOrder?: string | undefined;
    shippingName?: string | undefined;
    shippingAddress?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingPostalCode?: string | undefined;
    shippingPhone?: string | undefined;
    shippingFax?: string | undefined;
    estimatedShipDate?: Date | undefined;
    orderId?: string | undefined;
    orderRows?: OrderRows[] | undefined;
}

export class OrderRows implements IOrderRows {
    lineNumber?: number | undefined;
    itemNumber?: string | undefined;
    description?: string | undefined;

    constructor(data?: IOrderRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data['LineNumber'];
            this.itemNumber = _data['ItemNumber'];
            this.description = _data['Description'];
        }
    }

    static fromJS(data: any): OrderRows {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['LineNumber'] = this.lineNumber;
        data['ItemNumber'] = this.itemNumber;
        data['Description'] = this.description;
        return data;
    }
}

export interface IOrderRows {
    lineNumber?: number | undefined;
    itemNumber?: string | undefined;
    description?: string | undefined;
}

export class ProjectHead implements IProjectHead {
    name?: string | undefined;
    projectStatus?: string | undefined;
    projectNumber?: string | undefined;
    estCompletionDate?: Date | undefined;

    constructor(data?: IProjectHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['Name'];
            this.projectStatus = _data['ProjectStatus'];
            this.projectNumber = _data['ProjectNumber'];
            this.estCompletionDate = _data['EstCompletionDate']
                ? new Date(_data['EstCompletionDate'].toString())
                : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectHead {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['Name'] = this.name;
        data['ProjectStatus'] = this.projectStatus;
        data['ProjectNumber'] = this.projectNumber;
        data['EstCompletionDate'] = this.estCompletionDate ? this.estCompletionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProjectHead {
    name?: string | undefined;
    projectStatus?: string | undefined;
    projectNumber?: string | undefined;
    estCompletionDate?: Date | undefined;
}

export class ShipmentHead implements IShipmentHead {
    shipmentId?: string | undefined;
    orderId?: string | undefined;
    shipDate?: Date | undefined;
    orderNumber?: string | undefined;
    pONumber?: string | undefined;
    carrier?: string | undefined;
    trackNumber?: string | undefined;
    readonly trackLink?: string | undefined;
    freightCharge?: number | undefined;
    shipToName?: string | undefined;
    shipToAddress?: string | undefined;
    shipToState?: string | undefined;
    shipToCity?: string | undefined;
    details?: ShipmentDetail[] | undefined;

    constructor(data?: IShipmentHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentId = _data['ShipmentId'];
            this.orderId = _data['OrderId'];
            this.shipDate = _data['ShipDate'] ? new Date(_data['ShipDate'].toString()) : <any>undefined;
            this.orderNumber = _data['OrderNumber'];
            this.pONumber = _data['PONumber'];
            this.carrier = _data['Carrier'];
            this.trackNumber = _data['TrackNumber'];
            (<any>this).trackLink = _data['TrackLink'];
            this.freightCharge = _data['FreightCharge'];
            this.shipToName = _data['ShipToName'];
            this.shipToAddress = _data['ShipToAddress'];
            this.shipToState = _data['ShipToState'];
            this.shipToCity = _data['ShipToCity'];
            if (Array.isArray(_data['Details'])) {
                this.details = [] as any;
                for (let item of _data['Details']) this.details!.push(ShipmentDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShipmentHead {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ShipmentId'] = this.shipmentId;
        data['OrderId'] = this.orderId;
        data['ShipDate'] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data['OrderNumber'] = this.orderNumber;
        data['PONumber'] = this.pONumber;
        data['Carrier'] = this.carrier;
        data['TrackNumber'] = this.trackNumber;
        data['TrackLink'] = this.trackLink;
        data['FreightCharge'] = this.freightCharge;
        data['ShipToName'] = this.shipToName;
        data['ShipToAddress'] = this.shipToAddress;
        data['ShipToState'] = this.shipToState;
        data['ShipToCity'] = this.shipToCity;
        if (Array.isArray(this.details)) {
            data['Details'] = [];
            for (let item of this.details) data['Details'].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IShipmentHead {
    shipmentId?: string | undefined;
    orderId?: string | undefined;
    shipDate?: Date | undefined;
    orderNumber?: string | undefined;
    pONumber?: string | undefined;
    carrier?: string | undefined;
    trackNumber?: string | undefined;
    trackLink?: string | undefined;
    freightCharge?: number | undefined;
    shipToName?: string | undefined;
    shipToAddress?: string | undefined;
    shipToState?: string | undefined;
    shipToCity?: string | undefined;
    details?: ShipmentDetail[] | undefined;
}

export class ShipmentDetail implements IShipmentDetail {
    packSlip?: string | undefined;
    palletID?: string | undefined;
    itemNumber?: string | undefined;
    quantity?: number | undefined;
    description?: string | undefined;

    constructor(data?: IShipmentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packSlip = _data['PackSlip'];
            this.palletID = _data['PalletID'];
            this.itemNumber = _data['ItemNumber'];
            this.quantity = _data['Quantity'];
            this.description = _data['Description'];
        }
    }

    static fromJS(data: any): ShipmentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['PackSlip'] = this.packSlip;
        data['PalletID'] = this.palletID;
        data['ItemNumber'] = this.itemNumber;
        data['Quantity'] = this.quantity;
        data['Description'] = this.description;
        return data;
    }
}

export interface IShipmentDetail {
    packSlip?: string | undefined;
    palletID?: string | undefined;
    itemNumber?: string | undefined;
    quantity?: number | undefined;
    description?: string | undefined;
}

export class UserInfo implements IUserInfo {
    crmUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactEmailAddress?: string | undefined;
    quickTickOnline?: Privelege | undefined;
    duct?: Privelege | undefined;
    news?: Privelege | undefined;
    opportunities?: Privelege | undefined;
    orders?: Privelege | undefined;
    resourceTraining?: Privelege | undefined;
    invoices?: Privelege | undefined;
    fullAccess?: Privelege | undefined;
    qFV?: Privelege | undefined;
    error?: boolean | undefined;
    errorMessage?: string | undefined;
    customerInformation?: CustomerData | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crmUserId = _data['CrmUserId'];
            this.firstName = _data['FirstName'];
            this.lastName = _data['LastName'];
            this.contactEmailAddress = _data['ContactEmailAddress'];
            this.quickTickOnline = _data['QuickTickOnline']
                ? Privelege.fromJS(_data['QuickTickOnline'])
                : <any>undefined;
            this.duct = _data['Duct'] ? Privelege.fromJS(_data['Duct']) : <any>undefined;
            this.news = _data['News'] ? Privelege.fromJS(_data['News']) : <any>undefined;
            this.opportunities = _data['Opportunities'] ? Privelege.fromJS(_data['Opportunities']) : <any>undefined;
            this.orders = _data['Orders'] ? Privelege.fromJS(_data['Orders']) : <any>undefined;
            this.resourceTraining = _data['ResourceTraining']
                ? Privelege.fromJS(_data['ResourceTraining'])
                : <any>undefined;
            this.invoices = _data['Invoices'] ? Privelege.fromJS(_data['Invoices']) : <any>undefined;
            this.fullAccess = _data['FullAccess'] ? Privelege.fromJS(_data['FullAccess']) : <any>undefined;
            this.qFV = _data['QFV'] ? Privelege.fromJS(_data['QFV']) : <any>undefined;
            this.error = _data['Error'];
            this.errorMessage = _data['ErrorMessage'];
            this.customerInformation = _data['CustomerInformation']
                ? CustomerData.fromJS(_data['CustomerInformation'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['CrmUserId'] = this.crmUserId;
        data['FirstName'] = this.firstName;
        data['LastName'] = this.lastName;
        data['ContactEmailAddress'] = this.contactEmailAddress;
        data['QuickTickOnline'] = this.quickTickOnline ? this.quickTickOnline.toJSON() : <any>undefined;
        data['Duct'] = this.duct ? this.duct.toJSON() : <any>undefined;
        data['News'] = this.news ? this.news.toJSON() : <any>undefined;
        data['Opportunities'] = this.opportunities ? this.opportunities.toJSON() : <any>undefined;
        data['Orders'] = this.orders ? this.orders.toJSON() : <any>undefined;
        data['ResourceTraining'] = this.resourceTraining ? this.resourceTraining.toJSON() : <any>undefined;
        data['Invoices'] = this.invoices ? this.invoices.toJSON() : <any>undefined;
        data['FullAccess'] = this.fullAccess ? this.fullAccess.toJSON() : <any>undefined;
        data['QFV'] = this.qFV ? this.qFV.toJSON() : <any>undefined;
        data['Error'] = this.error;
        data['ErrorMessage'] = this.errorMessage;
        data['CustomerInformation'] = this.customerInformation ? this.customerInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserInfo {
    crmUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactEmailAddress?: string | undefined;
    quickTickOnline?: Privelege | undefined;
    duct?: Privelege | undefined;
    news?: Privelege | undefined;
    opportunities?: Privelege | undefined;
    orders?: Privelege | undefined;
    resourceTraining?: Privelege | undefined;
    invoices?: Privelege | undefined;
    fullAccess?: Privelege | undefined;
    qFV?: Privelege | undefined;
    error?: boolean | undefined;
    errorMessage?: string | undefined;
    customerInformation?: CustomerData | undefined;
}

export class Privelege implements IPrivelege {
    create?: boolean | undefined;
    read?: boolean | undefined;
    update?: boolean | undefined;

    constructor(data?: IPrivelege) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.create = _data['Create'];
            this.read = _data['Read'];
            this.update = _data['Update'];
        }
    }

    static fromJS(data: any): Privelege {
        data = typeof data === 'object' ? data : {};
        let result = new Privelege();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['Create'] = this.create;
        data['Read'] = this.read;
        data['Update'] = this.update;
        return data;
    }
}

export interface IPrivelege {
    create?: boolean | undefined;
    read?: boolean | undefined;
    update?: boolean | undefined;
}

export class CustomerData implements ICustomerData {
    salesCurentYearToDate?: number | undefined;
    salesPreviousYearToDate?: number | undefined;
    salesPreviousYear?: number | undefined;
    territoryName?: string | undefined;
    ranking?: number | undefined;

    constructor(data?: ICustomerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesCurentYearToDate = _data['SalesCurentYearToDate'];
            this.salesPreviousYearToDate = _data['SalesPreviousYearToDate'];
            this.salesPreviousYear = _data['SalesPreviousYear'];
            this.territoryName = _data['TerritoryName'];
            this.ranking = _data['Ranking'];
        }
    }

    static fromJS(data: any): CustomerData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['SalesCurentYearToDate'] = this.salesCurentYearToDate;
        data['SalesPreviousYearToDate'] = this.salesPreviousYearToDate;
        data['SalesPreviousYear'] = this.salesPreviousYear;
        data['TerritoryName'] = this.territoryName;
        data['Ranking'] = this.ranking;
        return data;
    }
}

export interface ICustomerData {
    salesCurentYearToDate?: number | undefined;
    salesPreviousYearToDate?: number | undefined;
    salesPreviousYear?: number | undefined;
    territoryName?: string | undefined;
    ranking?: number | undefined;
}

export enum Rate {
    Notdefined = 'notdefined',
    Hot = 'hot',
    Warm = 'warm',
    Cold = 'cold'
}

export enum StatusCode {
    Open = 'open',
    Won = 'won',
    Lost = 'lost'
}

export enum OpportunityHeadRate {
    Notdefined = 'notdefined',
    Hot = 'hot',
    Warm = 'warm',
    Cold = 'cold'
}

export enum OpportunityHeadStatusCode {
    Open = 'open',
    Won = 'won',
    Lost = 'lost'
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
): any {
    if (result !== null && result !== undefined) throw result;
    else throw new SwaggerException(message, status, response, headers, null);
}



// WEBPACK FOOTER //
// ./src/data/apiClient/client.ts